export default {"src":"/_next/static/media/arbitrum-explorer.5e26a404.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};